import styled from "@emotion/styled";

export const CalendarContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  min-height: 350px;
  padding-bottom: 48px; // for MobileInfo
  .fc-button-active {
    background-color: #ec9324 !important;
    border: 1px solid rgba(236, 147, 36, 0.5) !important;
    color: white;
  }
  .fc-button {
    background-color: transparent;
    color: #ec9324;
    border: 1px solid rgba(236, 147, 36, 0.5);
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover,
    &:focus,
    &:active {
      background-color: rgba(236, 147, 36, 0.04);
      border: 1px solid #ec9324;
      color: #ec9324;
    }
    &:focus,
    &:active {
      background-color: #ec9324 !important;
      border: 1px solid rgba(236, 147, 36, 0.5) !important;
      color: white !important;
    }
    &:disabled {
      background-color: rgba(236, 147, 36, 0.5);
      border: none;
      opacity: 1;
      &:hover {
        color: white !important;
      }
    }
    box-shadow: none !important;

    text-transform: capitalize;
  }

  @media (max-width: 600px) {
  .fc-header-toolbar {
    flex-direction: column !important; /* Chunks go vertically */
    align-items: stretch;
    gap: 2px;
  }
  .fc-toolbar-chunk {
    flex-direction: row !important;    /* Inside chunk: row layout */
    justify-content: space-between;
    align-items: center;
    gap: 3px;
    width: 100%;
    margin-bottom: 2px;
  }
  .fc-toolbar-title {
    width: 100%;
    text-align: center;
    font-size: 1.15em;
    margin-left: 0;
  }
}
  .fc-custom1-button {
    background-color: #ffffff;
    color: var(--green-color);
    text-decoration: underline;
    border: none;
    &:hover,
    &:focus,
    &:active {
      background-color: #ffffff;
      color: var(--green-color);
      text-decoration: underline;
      border: none;
      box-shadow: none;
    }
  }

  .fc-myCustomButton-button {
    border: none;
    background: none;
    color: inherit;
    text-decoration: none;
    cursor: default;
  }

  .fc-myCustomButton-button:hover,
  .fc-myCustomButton-button:active,
  .fc-myCustomButton-button:focus {
    border: none !important;
    background: none !important;
    color: inherit !important;
    text-decoration: none !important;
    outline: none !important;
    cursor: default;
  }
`;

export const MobileInfo = styled.div`
  display: none;
  @media (max-width: 600px) {
    display: block;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    background: #2f498e;
    z-index: 100;
    color: white;
    padding: 4px 10px;
    text-align: center;
  }
`;
